import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapsible from './SecondaryNavMobileCollapsible';

import * as styles from './SecondaryNavMobile.module.less';

const SecondaryNavMobile = ({ links }) => {
  const [isSecondaryNavOpen, setIsSecondaryNavOpen] = useState(false);
  const onSecondaryNavMobileClick = () => {
    setIsSecondaryNavOpen(!isSecondaryNavOpen);
  };

  return (
    <div className={styles.navMobile}>
      {links.map(link => {
        return (
          <Collapsible
            key={`${link.path}-${link.text}`}
            onClick={onSecondaryNavMobileClick}
            isOpen={isSecondaryNavOpen}
            text={link.text}
            link={link}
          />
        );
      })}
    </div>
  );
};

SecondaryNavMobile.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

SecondaryNavMobile.defaultProps = {
  links: [],
};

export default SecondaryNavMobile;
